import enviro from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const URL = `https://app.hubspot${enviro.isQa() ? 'qa' : ''}.com/live-messages/${enviro.isQa() ? '99535353' : '53'}/inbox`;
function CopyConversationLink() {
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  return /*#__PURE__*/_jsxs(UICopyButton, {
    use: "link",
    value: `${URL}/${ticket.conversationId}`,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.panel.body.links.copyLink"
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "duplicate",
      size: "xxs"
    })]
  });
}
export default CopyConversationLink;